<style scoped>
.news-list-content {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.news-title {
  font-size: 28px;
  text-align: center;
  padding: 20px 0;
}
.list {
  width: 100%;
  padding: 20px 10%;
  box-sizing: border-box;
  min-height: 470px;
}
.item {
  display: flex;
  height: 30px;
  line-height: 30px;
}
.item a {
  flex: 1;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item a:hover {
  color: red;
}
.item span {
  width: 100px;
  display: inline-block;
}
.list-footer {
  width: 100%;
  display: flex;
  justify-content: center;
}
.news-footer {
  margin: 0 auto;
}
.news-footer span {
  cursor: pointer;
}
</style>
<template>
  <div class="news-list-content">
    <div class="news-title">企业头条</div>
    <div class="list">
      <div class="item" v-for="item in newsList" :key="item.newsId">
        <a :href="item.link" target="_blank">{{ item.title }}</a>
        <span>{{ item.date }}</span>
      </div>
    </div>
    <div class="list-footer">
      <Page
        :total="total"
        :show-total="true"
        @on-change="changePageNo"
        :page-size="pageSize"
        size="small"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { rangeData, group } from "static/common.js";
export default {
  data() {
    return {
      newsList: [],
      allList: [],
      groupList: [],
      total: 0,
      pageNo: 1,
      pageSize: 15,
      data: [],
    };
  },
  methods: {
    changePageNo(e) {
      this.pageNo = e;
      this.newsList = this.groupList[this.pageNo - 1];
    },
    reqNewsList() {
      axios.get("./data.json").then((res) => {
        this.allList = rangeData(res.data.newsList);
        this.total = this.allList.length;
        this.groupList = group(this.allList, this.pageSize);
        this.newsList = this.groupList[this.pageNo - 1];
      });
    },
  },
  mounted() {
    this.reqNewsList();
  },
};
</script>

